// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AUTHOR = "autor";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
